import {
	CLOSE_MODAL_FAIL,
	CLOSE_MODAL_SUCCESS,
	OPEN_MODAL_FAIL,
	OPEN_MODAL_SUCCESS,
} from './types';

//open modal with ID prodvided (ex: openModal(clientDetails))
export const openModal = (modalId) => {
	return async (dispatch) => {
		try {
			var payload = {
				[modalId]: true,
			};

			var payloadFail = {
				[modalId]: false,
			};

			console.log('payload', payload);
			dispatch(setOpenModalSuccess(payload, modalId));
		} catch (error) {
			dispatch(setOpenModalFail(payloadFail, modalId));
		}
	};
};

//close modal with ID prodvided (ex: closeModal(clientDetails))
export const closeModal = (modalId) => {
	return async (dispatch) => {
		try {
			var payload = {
				[modalId]: false,
			};

			dispatch(setCloseModalSuccess(payload, modalId));
		} catch (error) {
			dispatch(setCloseModalFail(payload, modalId));
		}
	};
};

//modals
export const setOpenModalSuccess = (payload, modalId) => ({
	type: OPEN_MODAL_SUCCESS,
	payload,
});

export const setOpenModalFail = (payload, modalId) => ({
	type: OPEN_MODAL_FAIL,
	payload,
});

export const setCloseModalSuccess = (payload, modalId) => ({
	type: CLOSE_MODAL_SUCCESS,
	payload,
});

export const setCloseModalFail = (payload, modalId) => ({
	type: CLOSE_MODAL_FAIL,
	payload,
});
